var map = {
	"./gallery_00.jpg": 2356,
	"./gallery_01.jpg": 2357,
	"./gallery_02.jpg": 2358,
	"./gallery_03.jpg": 2359,
	"./gallery_04.jpg": 2360,
	"./gallery_05.jpg": 2361,
	"./gallery_06.jpg": 2362,
	"./gallery_07.jpg": 2363,
	"./gallery_08.jpg": 2364,
	"./gallery_09.jpg": 2365,
	"./gallery_10.jpg": 2366
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2355;